import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";
import SEO from "@/components/SEO";
import { AuthProvider } from "@/contexts/AuthContext";
import { CurrencyProvider } from "@/contexts/CurrencyContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import CategoriesPage from "@/pages/CategoriesPage";
import CategoryPage from "@/pages/CategoryPage";
import SearchPage from "@/pages/SearchPage";
import ForHotelsPage from "@/pages/ForHotelsPage";
import GetQuotesPage from "@/pages/GetQuotesPage";
import RFQResendPage from "@/pages/RFQResendPage";
import ListingDetailPage from "@/pages/ListingDetailPage";
import ProductPage from "@/pages/ProductPage";
import LinenBuyersPlaybookPage from "@/pages/LinenBuyersPlaybookPage";
import MarketBenchmarksPage from "@/pages/MarketBenchmarksPage";
import { LoginPage, RegisterPage, ForgotPasswordPage, ResetPasswordPage } from "@/pages/AuthPages";
import UnsubscribePage from "@/pages/UnsubscribePage";
import EmailPreferencesPage from "@/pages/EmailPreferencesPage";
import DashboardPage from "@/pages/DashboardPage";
import EnterpriseSetupPage from "@/pages/EnterpriseSetupPage";
import BuyerDashboardPage from "@/pages/BuyerDashboardPage";
import PricingPage from "@/pages/PricingPage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import AdminPage from "@/pages/AdminPage";
import { TermsPage, PrivacyPage, PaymentsRefundsPage } from "@/pages/LegalPages";
import ContactPage from "@/pages/ContactPage";
import OnboardingPage from "@/pages/OnboardingPage";
import AdminEmailPreviewPage from "@/pages/AdminEmailPreviewPage";
import NotFoundPage from "@/pages/NotFoundPage";
import CookieConsent from "@/components/CookieConsent";
import ImpersonationBanner from "@/components/ImpersonationBanner";

const BARE_ROUTES = ["/get-quotes"];  // standalone landing pages: no header, no footer
const Chrome = ({ children }) => { const { pathname } = useLocation(); return BARE_ROUTES.includes(pathname) ? null : children; };

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <CurrencyProvider>
        <BrowserRouter>
        <SEO />
        <div className="App min-h-screen flex flex-col">
          <ImpersonationBanner />
          <Chrome><Header /></Chrome>
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/categories" element={<CategoriesPage />} />
              <Route path="/category/:id" element={<CategoryPage />} />
              <Route path="/search" element={<SearchPage />} />
              <Route path="/for-hotels" element={<ForHotelsPage />} />
              <Route path="/get-quotes" element={<GetQuotesPage />} />
              <Route path="/rfq/resend/:id" element={<RFQResendPage />} />
              <Route path="/listing/:id" element={<ListingDetailPage />} />
              <Route path="/product/:id" element={<ProductPage />} />
              <Route path="/resources/linen-buyers-playbook" element={<LinenBuyersPlaybookPage />} />
              <Route path="/resources/market-benchmarks" element={<MarketBenchmarksPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              <Route path="/unsubscribe" element={<UnsubscribePage />} />
              <Route path="/email-preferences" element={<EmailPreferencesPage />} />
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/dashboard/enterprise-setup" element={<EnterpriseSetupPage />} />
              <Route path="/buyer" element={<BuyerDashboardPage />} />
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/payment/success" element={<PaymentSuccessPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/payments-refunds" element={<PaymentsRefundsPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/onboarding" element={<OnboardingPage />} />
              <Route path="/admin/email-preview" element={<AdminEmailPreviewPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </main>
          <Chrome><Footer /></Chrome>
          <CookieConsent />
          <Toaster position="top-right" richColors />
        </div>
      </BrowserRouter>
      </CurrencyProvider>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
